<template>
  <el-dialog title="库存详情" :visible.sync="dialogVisible" width="80%">
    <el-tabs v-model="form.isModelCodeType" @tab-click="handleTab">
      <el-tab-pane label="商品库存管理" name="1"></el-tab-pane>
      <el-tab-pane label="型号库存管理" name="2"></el-tab-pane>
    </el-tabs>
    <el-form ref="form" :model="form" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="仓名查询" prop="stockName">
            <el-input v-model="form.stockName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="仓级筛选" prop="level">
            <el-select v-model="form.level" style="width: 100%;" clearable>
              <el-option :value="null" label="全部"></el-option>
              <el-option :value="1" label="一级"></el-option>
              <el-option :value="2" label="二级"></el-option>
              <el-option :value="3" label="三级"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="区域查询" prop="deliverArea">
            <el-input v-model="form.deliverArea"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-button type="primary" @click="getData">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="tableData" border style="width: 100%;" :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }">
      <el-table-column label="仓名" prop="stockName" width="200"></el-table-column>
      <el-table-column label="仓级" prop="stockLevel" width="100"></el-table-column>
      <el-table-column label="发货区域" prop="deliverAreaName"></el-table-column>
      <el-table-column label="库存量" width="200">
        <template slot-scope="scope">
          <el-input :disabled="!scope.row.updateStockNum" v-model="scope.row.stockNum"></el-input>
          <el-button type="text" @click="updateStockNum(scope.row)">{{ scope.row.updateStockNum ? "保存" : "编辑"
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page="form.pageIndex" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="form.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
    <span slot="footer">
      <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  KSAXApiRequest,
} from "../../../api/api";

export default {
  data() {
    return {
      tableData: [],
      total: 0,
      form: {},
      dialogVisible: false,
      modelCode: null,
      skuId: null
    };
  },
  methods: {
    queryData() {
      KSAXApiRequest({
        path: 'Product_MultistageStockSku/List',
        parmsJson: {
          ...this.form,
          calculateStoreValue: this.form.calculateStoreValue || 0
        }
      }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.response.data || []
          this.tableData.forEach(item => {
            this.$set(item, "updateStockNum", false)
          });
          this.total = res.data.response.dataCount
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getData() {
      this.form.pageIndex = 1
      this.form.pageSize = 10
      this.queryData()
    },
    handleSizeChange(value) {
      this.form.pageSize = value
      this.queryData()
    },
    handleCurrentChange(value) {
      this.form.pageIndex = value
      this.queryData()
    },
    resetForm() {
      this.$refs["form"].resetFields();
      this.getData()
    },
    init(skuId, modelCode, supId,) {
      this.dialogVisible = true
      this.modelCode = modelCode
      this.skuId = skuId
      this.form = {
        skuId: null,
        spuId: null,
        modelCode: null,
        level: null,
        stockName: null,
        deliverArea: null,
        calculateStoreType: null,
        calculateStoreValue: null,
        pageIndex: 1,
        pageSize: 10,
        supId,
        isModelCodeType: "1"
      }
      this.handleTab()
    },
    updateStockNum(row) {
      if (row.updateStockNum) {
        this.$confirm('确定修改?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit("update:loading", true)
          KSAXApiRequest({
            path: 'Product_MultistageStockSku/UpdateStockNum',
            parmsJson: {
              id: row.id,
              stockNum: row.stockNum
            }
          }).then(res => {
            this.$emit("update:loading", false)
            if (res.data.success) {
              this.$message.success(res.data.msg)
              this.queryData()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
      } else {
        row.updateStockNum = !row.updateStockNum
      }
    },
    handleTab() {
      if (this.form.isModelCodeType === "1") {
        this.form.skuId = this.skuId
        this.form.modelCode = null
      } else if (this.form.isModelCodeType === "2") {
        this.form.skuId = null
        this.form.modelCode = this.modelCode
      }
      this.getData()
    }
  },
};
</script>

<style scoped></style>
